<template>
    <div class="comisiones">
        <el-row :gutter="0">
            <el-col :sm="12" :offset="0">
                <table class="table table-bordered table-com">

                    <tr>
                        <td>Fecha inicio</td>
                        <th>{{ com.fecha_inicio | moment('LL') }}</th>
                    </tr>
                    <tr>
                        <td>Fecha fin</td>
                        <th>{{ com.fecha_fin | moment('LL') }}</th>
                    </tr>
                    <tr>
                        <td>Lugar</td>
                        <th>{{ com.lugar + ' - ' + com.direccion }}</th>
                    </tr>
                    <tr>
                        <td>Encuentros</td>
                        <th>{{ com.cantidad_encuentros }}</th>
                    </tr>
                    <tr v-if="com.tienePre">
                        <td colspan="2" class="td-pre">
                            Preinscripciones
                            <small style="float:right; padding-top:2px">COM#{{ com.id }}</small>

                        </td>
                    </tr>
                    <tr>
                        <td class="cupos">Cupo Real</td>
                        <th class="cupos">{{ com.cupo }}</th>
                    </tr>
                    <tr v-if="com.tienePre">
                        <td class="cupos">Cupo Preinscripción</td>
                        <th class="cupos">{{ com.cupo_preinscripcion }}</th>
                    </tr>
                    <tr v-if="com.tienePre">
                        <td class="cupos">Inicio Preinscripción</td>
                        <th class="cupos">{{ com.fecha_apertura_preinscripcion | moment('DD/MM/YYYY [a las] HH:mm [hs]')
                            }}</th>
                    </tr>

                    <tr v-if="com.tienePre">
                        <td class="cupos">Cierre Preinscripción</td>
                        <th class="cupos">{{ com.fecha_cierre_preinscripcion | moment('DD/MM/YYYY [a las] HH:mm [hs]')
                            }}</th>
                    </tr>
                </table>
            </el-col>
            <el-col :sm="12" :offset="0">
                <div class="table-p" v-html="com.cronograma"></div>
            </el-col>
        </el-row>

        <div style="padding: 20px 20px;background: #FFF3E0;font-size: 15px;">
            Estimada/o docente recuerde que debe verificar el cupo real del curso, los destinatarios y el cronograma. Si
            considera que su N° de orden está alejado de la posibilidad de inscripción, no es destinatario y/o no puede
            asistir a las fechas convocadas, debe generar la baja desde su Espacio de Formación Personal para evitar
            sanciones. Esta posibilidad estará vigente mientras dure la etapa de preinscripción.
        </div>

        <!-- <div class="table-p"  v-html="com.cronograma"></div> -->
    </div>


</template>

<script>

    export default {
    props: ['com'],
    }
</script>

<style lang="scss" scoped>
.comisiones table {
    margin: 0
}

.comisiones table>tr>td,
.comisiones table>tr>th {
    font-size: 14px;
}

.td-pre {
    background: #9E9E9E;
    color: white;
    font-size: 18px !important;
}

.cupos {
    background-color: #FFFDE7;
}

tr:nth-child(odd) .cupos {
    background-color: #e0e0e0;
}
.comisiones table>tr>td {
    padding-left: 20px;
}
@media screen and (max-width:768px) {
    .comisiones {

        margin-top: 0px;
        border-top: 20px solid #ffc60a;
    }

    .comisiones h3 {
        padding: 10px 20px;
        padding-right: 8px;


    }

    .comisiones table>tr>td {
        padding-left: 20px;
    }
}
</style>